var _path, _g, _g2, _g3, _g4, _rect, _circle, _rect2, _circle2, _rect3, _circle3, _rect4, _circle4, _rect5, _circle5, _rect6, _circle6, _rect7, _circle7, _rect8, _circle8, _rect9, _circle9, _rect0, _circle0, _rect1, _circle1, _rect10, _circle10, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 64,
    viewBox: "0 0 68 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.999 2.4541C40.6042 2.4542 44.0956 4.80756 45.583 6.19629C45.9392 6.52886 46.0962 6.67562 46.2754 7.08789C46.4529 7.49652 46.4551 7.80384 46.4551 8.49805V21.7344C46.4551 22.5395 46.4525 22.9009 46.334 23.2412C46.2153 23.5817 46.0026 23.8538 45.5234 24.458C42.4972 28.2743 40.0414 30.4678 36.0547 32.877C35.0188 33.503 34.5541 33.7771 33.9824 33.7881C33.4107 33.799 32.9393 33.5447 31.8867 32.9629C27.7422 30.6717 25.2632 28.4788 22.3389 24.4014C21.9303 23.8317 21.7488 23.5761 21.6465 23.2578C21.5443 22.9398 21.542 22.6078 21.542 21.8682V8.49805C21.542 7.80384 21.5442 7.49652 21.7217 7.08789C21.9008 6.67557 22.0579 6.52887 22.4141 6.19629C23.9014 4.80754 27.3935 2.4541 33.999 2.4541Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.361853
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_3184_16683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4473 11.4156C24.4473 10.4641 24.4473 9.98833 24.8033 9.27972C25.1593 8.57111 25.3941 8.39644 25.8636 8.04708C27.2868 6.98822 29.8958 5.70703 34.1892 5.70703C38.4825 5.70703 41.0916 6.98822 42.5147 8.04708C42.9843 8.39643 43.2191 8.57111 43.5751 9.27972C43.9311 9.98833 43.9311 10.4641 43.9311 11.4156V19.6788C43.9311 20.8216 43.9311 21.393 43.7315 21.9445C43.5319 22.4961 43.1993 22.8955 42.5341 23.6944C40.8271 25.7444 39.281 27.164 37.2107 28.5519C35.8352 29.4741 35.1474 29.9351 34.1582 29.9504C33.169 29.9656 32.4794 29.5336 31.1003 28.6694C28.919 27.3027 27.3424 25.8416 25.6469 23.6062C25.0799 22.8586 24.7963 22.4848 24.6218 21.9659C24.4473 21.447 24.4473 20.9211 24.4473 19.8691V11.4156Z",
    fill: "#55E6C1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3184_16683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2637 11.2027C26.2637 10.7671 26.2637 10.5493 26.3913 10.2687C26.519 9.98819 26.6371 9.88522 26.8735 9.67928C27.8409 8.83637 30.0554 7.45703 34.1893 7.45703C38.3232 7.45703 40.5377 8.83637 41.5051 9.67928C41.7414 9.88522 41.8596 9.98819 41.9873 10.2687C42.1149 10.5493 42.1149 10.7671 42.1149 11.2026V19.7513C42.1149 20.4002 42.1149 20.7247 42.0082 21.0316C41.9014 21.3385 41.7084 21.5823 41.3224 22.07C39.4856 24.3909 37.9465 25.9077 35.4836 27.4368C34.8762 27.8139 34.5725 28.0025 34.182 28.01C33.7915 28.0176 33.4826 27.842 32.8649 27.4908C30.2928 26.0285 28.7315 24.5044 26.9423 22.0171C26.6135 21.5601 26.4491 21.3316 26.3564 21.0439C26.2637 20.7562 26.2637 20.4577 26.2637 19.8608L26.2637 11.2027Z",
    fill: "#4846BC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_3184_16683)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.2408,
    cy: 8.33647,
    r: 2.53569,
    fill: "#4846BC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dii_3184_16683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9844 17.5772L32.7843 20.3827L38.2676 14.8887",
    stroke: "#D4D1F7",
    strokeWidth: 2.36664,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.7272,
    y: 6.33851,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7225,
    cy: 7.3338,
    r: 0.54278,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3346,
    y: 6.33851,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3299,
    cy: 7.3338,
    r: 0.54278,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7272,
    y: 22.2643,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7225,
    cy: 23.2596,
    r: 0.54278,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.7461,
    y: 3.04496,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.3264,
    cy: 3.62522,
    r: 0.316622,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.9102,
    y: 3.04496,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.4904,
    cy: 3.62522,
    r: 0.316622,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40.7461,
    y: 28.5508,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.3264,
    cy: 29.1311,
    r: 0.316622,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 25.9102,
    y: 28.5508,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.4904,
    cy: 29.1311,
    r: 0.316622,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3346,
    y: 22.2643,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3299,
    cy: 23.2596,
    r: 0.54278,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 33.0319,
    y: 32.7506,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.0272,
    cy: 33.7459,
    r: 0.54278,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 33.0319,
    y: 1.27601,
    width: 1.99019,
    height: 1.99019,
    rx: 0.995097,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.180927
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.0272,
    cy: 2.2713,
    r: 0.54278,
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0254,
    y: 14.7129,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6057,
    cy: 15.2932,
    r: 0.316622,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 45.8106,
    y: 14.7129,
    width: 1.16095,
    height: 1.16095,
    rx: 0.580473,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.105541
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3908,
    cy: 15.2932,
    r: 0.316622,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4996 61.1072L52.8874 60.3864L52.0449 58.6504H52.5313L53.1112 59.9369L53.6981 58.6504H54.188L52.9755 61.1072H52.4996Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2194 60.408H49.7559L49.7611 57.9512H50.2194V58.8007C50.4185 58.6843 50.6794 58.6174 50.9173 58.6174H51.0107C51.3755 58.6174 51.6769 58.776 51.8461 59.0509C52.017 59.3258 52.0153 59.7453 51.8461 60.0149C51.6769 60.2899 51.3755 60.4485 51.0107 60.4485H50.9173C50.6794 60.4485 50.4185 60.3815 50.2194 60.2652V60.408ZM50.2194 59.6166C50.2564 59.9092 50.4925 60.0925 50.8873 60.0925C51.2751 60.0925 51.5042 59.8792 51.5042 59.532C51.5042 59.1866 51.2751 58.9734 50.8873 58.9734C50.4925 58.9734 50.2564 59.1567 50.2194 59.4475V59.6166Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5777 57.5028C57.0073 57.4787 57.5423 57.5927 57.9485 57.7351C57.9466 57.9635 57.9447 58.192 57.9427 58.4209C57.7451 58.4507 57.7408 58.3636 57.6217 58.296C57.259 58.0922 56.7404 57.9522 56.337 58.1149C55.9863 58.2563 55.9543 58.6824 56.1763 58.8063C56.6174 59.0518 57.9408 58.8631 58.0748 59.8435C58.1269 60.2247 58.037 60.5194 57.7365 60.7672C57.1021 61.2903 56.0854 61.1342 55.3906 60.8069C55.3925 60.5747 55.3945 60.3425 55.3964 60.1098C55.6241 60.0748 55.6581 60.1869 55.8208 60.2796C56.181 60.4853 56.6461 60.6589 57.0595 60.5061C57.315 60.412 57.5322 60.1093 57.4093 59.8658C57.2514 59.5531 56.283 59.5645 55.9581 59.4179C55.0275 58.9983 55.272 57.5771 56.5777 57.5028Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5853 57.5028C58.7978 57.5047 59.0097 57.5066 59.2221 57.5085C59.2241 57.9489 59.226 58.3887 59.2279 58.829H60.6504C60.6523 58.3887 60.6542 57.9489 60.6561 57.5085H61.2872C61.2853 58.708 61.2834 59.9074 61.2814 61.1068C61.0728 61.1049 60.8647 61.103 60.6561 61.1011C60.6542 60.5402 60.6523 59.9793 60.6504 59.4183H59.2279C59.226 59.9793 59.2241 60.5402 59.2221 61.1011H58.5796C58.5815 59.9017 58.5834 58.7023 58.5853 57.5028Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8886 57.8543V58.4549C64.8914 58.5013 64.7087 58.4965 64.6761 58.489C64.6206 58.4757 64.2838 58.0874 63.6436 58.0468C62.2164 57.9569 62.147 59.7461 62.8293 60.3132C63.2106 60.6305 63.8034 60.5719 64.246 60.421V59.7749C63.9575 59.7731 63.6685 59.7712 63.38 59.7693V59.18C63.8828 59.1837 64.3857 59.1875 64.8886 59.1913V60.744C64.8508 60.8287 64.5647 60.929 64.4584 60.9592C64.0627 61.0732 63.2049 61.1584 62.8183 61.0501C61.9523 60.8074 61.6369 59.5858 61.8145 58.8115C62.08 57.6551 63.2039 57.3203 64.2752 57.5818C64.3982 57.6116 64.8446 57.7582 64.8891 57.8538L64.8886 57.8543Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25537 55.1933C4.67415 55.1933 4.13083 55.083 3.62541 54.8626C3.12 54.6421 2.67523 54.3376 2.29112 53.9492C1.91206 53.5555 1.61386 53.0961 1.39654 52.5712C1.18426 52.041 1.07812 51.4688 1.07812 50.8546C1.07812 50.2352 1.18679 49.6657 1.40412 49.146C1.62145 48.621 1.91964 48.1669 2.2987 47.7837C2.67776 47.3953 3.11495 47.0961 3.61025 46.8861C4.11061 46.6709 4.6413 46.5633 5.20231 46.5633C5.66729 46.5633 6.11963 46.6367 6.55934 46.7837C6.99905 46.9255 7.3857 47.1197 7.71927 47.3664L7.05212 48.894C6.90555 48.7523 6.73371 48.6315 6.5366 48.5318C6.33949 48.432 6.12974 48.3559 5.90736 48.3034C5.68498 48.2457 5.46512 48.2168 5.24779 48.2168C4.78281 48.2168 4.36837 48.3297 4.00447 48.5554C3.64563 48.7811 3.36007 49.0961 3.1478 49.5003C2.94058 49.8993 2.83697 50.356 2.83697 50.8704C2.83697 51.3743 2.94058 51.8284 3.1478 52.2326C3.35502 52.6368 3.64058 52.957 4.00447 53.1933C4.36837 53.4242 4.78534 53.5397 5.25537 53.5397C5.62938 53.5397 5.98064 53.4741 6.30916 53.3429C6.64274 53.2064 6.9005 53.0489 7.08245 52.8704L7.74201 54.4216C7.44887 54.6368 7.0875 54.8206 6.6579 54.9728C6.2283 55.1198 5.76079 55.1933 5.25537 55.1933Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3741 55.2248C11.6059 55.2248 10.916 55.041 10.3045 54.6736C9.69291 54.3009 9.20772 53.7891 8.84887 53.1381C8.49003 52.482 8.31061 51.726 8.31061 50.8704C8.31061 50.02 8.49003 49.2719 8.84887 48.6263C9.20772 47.9806 9.69291 47.4766 10.3045 47.1144C10.916 46.7522 11.6059 46.5711 12.3741 46.5711C13.1525 46.5711 13.8474 46.7522 14.459 47.1144C15.0705 47.4766 15.5532 47.9806 15.907 48.6263C16.2608 49.2719 16.4377 50.02 16.4377 50.8704C16.4377 51.726 16.2582 52.482 15.8994 53.1381C15.5456 53.7891 15.0604 54.3009 14.4438 54.6736C13.8323 55.041 13.1424 55.2248 12.3741 55.2248ZM12.3741 53.5791C12.8189 53.5791 13.2157 53.4662 13.5644 53.2405C13.9131 53.0148 14.186 52.6998 14.3832 52.2956C14.5853 51.8862 14.6864 51.4111 14.6864 50.8704C14.6864 50.3402 14.5879 49.8756 14.3907 49.4767C14.1936 49.0777 13.9207 48.768 13.572 48.5475C13.2283 48.3271 12.8315 48.2168 12.3817 48.2168C11.937 48.2168 11.5402 48.3271 11.1915 48.5475C10.8427 48.768 10.5673 49.0777 10.3651 49.4767C10.168 49.8756 10.0694 50.3402 10.0694 50.8704C10.0694 51.4111 10.168 51.8862 10.3651 52.2956C10.5673 52.6998 10.8402 53.0148 11.1839 53.2405C11.5326 53.4662 11.9294 53.5791 12.3741 53.5791Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8705 55.0988V46.6971H19.6066V47.7286H19.8871L19.2351 48.5475C19.4626 47.9176 19.8012 47.432 20.251 47.0908C20.7008 46.7444 21.229 46.5711 21.8355 46.5711C22.4016 46.5711 22.8792 46.7207 23.2683 47.02C23.6626 47.3139 23.9405 47.7102 24.1023 48.2089L23.6247 47.7522H24.2766L23.6929 48.2089C23.9456 47.6578 24.3171 47.2483 24.8073 46.9806C25.2976 46.7076 25.8308 46.5711 26.407 46.5711C26.8972 46.5711 27.3142 46.6577 27.6579 46.831C28.0066 47.0042 28.2871 47.2378 28.4994 47.5318C28.7167 47.8257 28.8759 48.1591 28.977 48.5318C29.0831 48.8992 29.1362 49.2798 29.1362 49.6735V55.0988H27.3395V49.9649C27.3395 49.3822 27.2131 48.9412 26.9604 48.642C26.7077 48.3376 26.364 48.1853 25.9294 48.1853C25.6514 48.1853 25.3961 48.2509 25.1636 48.3822C24.9312 48.5134 24.7442 48.7103 24.6026 48.9727C24.4662 49.2352 24.3979 49.5659 24.3979 49.9649V55.0988H22.6088V49.9649C22.6088 49.3822 22.4799 48.9412 22.2221 48.642C21.9694 48.3376 21.6257 48.1853 21.1911 48.1853C20.7716 48.1853 20.4102 48.3376 20.107 48.642C19.8088 48.9465 19.6597 49.4006 19.6597 50.0042V55.0988H17.8705Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9405 58.4059V46.6971H32.6766V47.6735H32.9117L32.5174 48.5082V53.1539L33.0254 54.1145H32.7297V58.4059H30.9405ZM35.1784 55.2248C34.5012 55.2248 33.8947 55.0332 33.3589 54.65C32.8283 54.2668 32.4088 53.7444 32.1005 53.083C31.7922 52.4216 31.6355 51.6788 31.6304 50.8546C31.6355 50.0305 31.7871 49.2956 32.0853 48.6499C32.3885 47.999 32.803 47.4871 33.3286 47.1144C33.8593 46.7417 34.4658 46.5554 35.1481 46.5554C35.7799 46.5554 36.3737 46.726 36.9297 47.0672C37.4857 47.4084 37.9329 47.9019 38.2716 48.5475C38.6153 49.1932 38.782 49.978 38.7719 50.9019C38.777 51.5896 38.681 52.2037 38.4838 52.7444C38.2867 53.2799 38.0189 53.7313 37.6802 54.0988C37.3416 54.4662 36.955 54.7471 36.5203 54.9413C36.0907 55.1303 35.6434 55.2248 35.1784 55.2248ZM34.807 53.6185C35.2315 53.6185 35.6106 53.5003 35.9441 53.2641C36.2777 53.0279 36.5355 52.7051 36.7174 52.2956C36.9044 51.8809 36.9954 51.4085 36.9903 50.8783C36.9954 50.3323 36.9044 49.8573 36.7174 49.4531C36.5304 49.0436 36.2676 48.726 35.929 48.5003C35.5954 48.2746 35.2138 48.1643 34.7842 48.1696C34.3799 48.1643 34.0135 48.2719 33.6849 48.4924C33.3615 48.7076 33.1012 49.0174 32.9041 49.4216C32.712 49.8258 32.616 50.3113 32.616 50.8783C32.616 51.4085 32.7095 51.8809 32.8965 52.2956C33.0885 52.7051 33.3488 53.0279 33.6774 53.2641C34.0059 53.5003 34.3824 53.6185 34.807 53.6185Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0925 55.2248C41.668 55.2248 41.3167 55.1303 41.0387 54.9413C40.7658 54.7523 40.5611 54.4899 40.4246 54.1539C40.2882 53.8179 40.2199 53.4295 40.2199 52.9885V42.9727H42.0091V52.8389C42.0091 52.9597 42.0217 53.0778 42.047 53.1933C42.0723 53.3087 42.1228 53.4059 42.1986 53.4846C42.2795 53.5581 42.4059 53.5948 42.5777 53.5948C42.6485 53.5948 42.7116 53.5896 42.7672 53.5791C42.8279 53.5633 42.881 53.5476 42.9264 53.5318V55.083C42.8203 55.1303 42.6914 55.1644 42.5398 55.1854C42.3932 55.2117 42.2441 55.2248 42.0925 55.2248Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3517 55.0988V46.6971H46.1409V55.0988H44.3517ZM45.2463 45.5239C44.9077 45.5239 44.6221 45.4031 44.3896 45.1617C44.1622 44.9202 44.0485 44.6262 44.0485 44.2798C44.0485 43.9333 44.1622 43.6393 44.3896 43.3979C44.6221 43.1564 44.9077 43.0356 45.2463 43.0356C45.5799 43.0356 45.8629 43.1564 46.0954 43.3979C46.3279 43.6393 46.4441 43.9333 46.4441 44.2798C46.4441 44.6262 46.3279 44.9202 46.0954 45.1617C45.8629 45.4031 45.5799 45.5239 45.2463 45.5239Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.739 54.8972L51.9466 43.6089H53.6545L57.8311 54.8972H56.0456L53.5614 48.092C53.5303 48.0167 53.4682 47.8339 53.3751 47.5437C53.2922 47.2534 53.1939 46.9309 53.08 46.5761C52.9662 46.2213 52.8627 45.8988 52.7695 45.6085C52.6764 45.3075 52.6143 45.114 52.5832 45.028L52.9403 45.0119C52.8782 45.1946 52.8006 45.4258 52.7074 45.7053C52.6246 45.9848 52.5315 46.2805 52.4279 46.5922C52.3348 46.904 52.2416 47.1996 52.1485 47.4792C52.0553 47.7479 51.9777 47.9737 51.9156 48.1565L49.4469 54.8972H47.739ZM49.6022 52.0913L50.2232 50.4141H55.1606L55.8748 52.0913H49.6022Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3402 54.8972V53.2846H61.0947V45.2215H59.3402V43.6089H64.526V45.2215H62.7715V53.2846H64.526V54.8972H59.3402Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_3184_16683",
    x: 21.2696,
    y: 4.53632,
    width: 23.8327,
    height: 28.5925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.00346,
    dy: 1.00346
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.08709
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3184_16683"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3184_16683",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.501732,
    dy: -0.501732
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.309401
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3184_16683"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3184_16683",
    x: 25.7619,
    y: 7.45703,
    width: 16.3533,
    height: 21.0545,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.501732,
    dy: 0.501732
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.878031
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.43 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3184_16683"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_3184_16683",
    x: 39.2825,
    y: 5.0274,
    width: 6.76273,
    height: 7.53611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.422615,
    dy: 0.84523
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.422615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3184_16683"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3184_16683",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.773385,
    dy: -0.773385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.422615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3184_16683"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dii_3184_16683",
    x: 26.1637,
    y: 12.3358,
    width: 15.2484,
    height: 12.4594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.338092,
    dy: 0.929753
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.14951
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0272251 0 0 0 0 0.0125 0 0 0 0 0.2 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3184_16683"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3184_16683",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.338092,
    dy: 0.929753
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.308509
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3184_16683"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.338092,
    dy: -0.929753
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.393032
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_3184_16683",
    result: "effect3_innerShadow_3184_16683"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.9314d3bc845dcdf4f24c4f198645f1ff.svg";
export { ForwardRef as ReactComponent };